import GameroomScenarioSettings from '@/components/scenario/GameroomScenario'

const GameroomScenarioSettingsScreen = () => {
  return <GameroomScenarioSettings />
}

export default GameroomScenarioSettingsScreen
